
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload, AppImageHolder } from '@/components';
import { usePiggybankAdd } from '@/modules/piggybank/model/add';
import { ROUTE_NAME_PIGGYBANK } from '@/modules/piggybank/router';

export default defineComponent({
    name: ROUTE_NAME_PIGGYBANK.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, actions, iapOptions } = usePiggybankAdd();

        return { v$, model, actions, iapOptions };
    }
});
